import React from 'react'

import MapComponent from '../../components/MapComponent/MapComponent'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { extraMargin, sectionContainer } from './MapSection.module.css'

const MapSection = ({ slice }) => {
  const { mapcontent, mapheading, mapkicker } = slice
  return (
    <SectionLayout
      extraClassName={sectionContainer}
      heading={mapheading}
      kicker={mapkicker}
      renderedContent={mapcontent}
      withHeader
    >
      <MapComponent extraClassName={extraMargin} />
    </SectionLayout>
  )
}

export default MapSection
